















import Vue from 'vue';
import HelpList from '@/parts/app/UninstallHelpList.vue';

export default Vue.extend({
  name: 'UninstallHelp',
  components: {
    HelpList,
  },
});

